/**
 * document.activeElement, with attribute-based fallback for disappearing triggers
 */
export function getOpener() {
  const currentFocus = document.activeElement;
  if (currentFocus instanceof HTMLElement) {
    const focusParent = currentFocus.closest("[data-return-focus-source]");
    if (focusParent) {
      const id = focusParent.getAttribute("data-return-focus-source");
      const destinationParent = document.querySelector(
        `[data-return-focus-destination="${id}"]`
      );
      return destinationParent?.closest("button") ?? undefined;
    } else {
      return currentFocus;
    }
  }
}

export function focusWithSetTabIndex(
  node: HTMLElement,
  options?: FocusOptions
) {
  node.setAttribute("tabindex", "-1");
  node.addEventListener(
    "blur",
    () => {
      node.removeAttribute("tabindex");
    },
    { once: true }
  );
  node.focus(options);
}

export function focusMainContent() {
  const main = document.querySelector<HTMLElement>("main");
  if (main) {
    focusWithSetTabIndex(main, { preventScroll: true });
    window.scroll(0, 0);
  } else {
    // eslint-disable-next-line no-console
    console.error("No main element present to focus");
  }
}
